import type { GoodsReceipt, Location, ProductWarehouseItem, PurchasingCostListEntry } from "@/graphql/codegen/graphql"
import type { PurchaseOrderLineWithReceiptContext } from "@/screens/WarehouseReceiving/types"

export interface ProductCostBreakdownRow {
  costBreakdown: Omit<ProductWarehouseItem, "goodsReceipt">
  goodsReceipt: GoodsReceipt | null
  purchaseOrderLine: PurchaseOrderLineWithReceiptContext | null
}

export enum ProductCostTabPathname {
  LaidDown = "laid-down",
  PurchaseCosts = "purchase-costs",
}

export enum PurchaseCostPackageLabel {
  Current = "Current",
  Future = "Future",
  Historic = "Historic",
}

// UI-only grouping of PurchasingCostListEntry by warehouse — not a schema type.
export interface PurchasingCostsByWarehouse {
  warehouseAreaId: string
  location: Location
  current: PurchasingCostListEntry[]
  future: PurchasingCostListEntry[]
}
